export enum ValidationDataType {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO',
  UNKNOWN = 'UNKNOWN'
}

export enum ValidationType {
  SCHEMA_VALIDATION = 'SCHEMA_VALIDATION',
  DATA_VALIDATION = 'DATA_VALIDATION',
  UNSPECIFIED_ERROR = 'UNSPECIFIED_ERROR'
}

/**
 * A Generic validation results model used in visualization of the validation messages.
 * This model can hold schema and data validation messages according to the needs. The type
 * property defines the purpose of the model in each scenario.
 */
export type ValidationResultModel = {
  errors?: ValidationDataModel[];
  warnings?: ValidationDataModel[];
  info?: ValidationDataModel[];
  type?: ValidationType;
}

export type ValidationDataModel = {
  message: string;
  type: ValidationDataType;
}

/**
 * A model which holds meta data generated from data validation operation.
 */
export type DataValidationReport = {
  id?: string;
  schemaId?: string;
  done?: boolean;
  createdOn?: string;
  completedOn?: string;
  canceledOn?: string;
  status?: ValidationStatus;
  totalTasksCount?: number;
  remainingTasksCount?: number;
  infoTasksCount?: number;
  warningTasksCount?: number;
  failedTasksCount?: number;
  successTasks: Array<DataValidationTask>;
  infoTasks: Array<DataValidationTask>;
  warningTasks: Array<DataValidationTask>;
  failedTasks: Array<DataValidationTask>;
}

export type DataValidationTask = {
  id: string;
  durationInMs: number;
  objectType: string;
  propertyName: string;
  status: string;
  result: string;
  queryable: boolean;
}

export enum ValidationStatus {
  DONE = 'DONE',
  RUNNING = 'RUNNING',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED'
}
